const workload = () =>
    import('@/views/workReport/workload/index.vue');
const consultClassifyReport = () =>
    import('@/views/workReport/consultClassifyReport/index.vue');
const trendCount = () =>
    import('@/views/workReport/trendCount/index.vue');
const workQuality = () =>
    import('@/views/workReport/workQuality/index.vue');
const workQualityDetail = () =>
    import('@/views/workReport/workQualityDetail/index.vue');

export default [
    {
        path: "/workReport/workload",
        name: "workload",
        components: {
            default: workload,
        },
        meta: {
            nav: "workReport",
            navChild: "workload",
            navName:"工作量统计",
            keepAlive: true
        },
    },
    {
        path: "/workReport/consultClassifyReport",
        name: "consultClassifyReport",
        components: {
            default: consultClassifyReport,
        },
        meta: {
            nav: "workReport",
            navChild: "consultClassifyReport",
            navName:"咨询分类统计",
            keepAlive: true
        },
    },
    {
        path: "/workReport/trendCount",
        name: "trendCount",
        components: {
            default: trendCount,
        },
        meta: {
            nav: "workReport",
            navChild: "trendCount",
            navName:"分时统计",
            keepAlive: true
        },
    },
    {
        path: "/workReport/workQuality",
        name: "workQuality",
        components: {
            default: workQuality,
        },
        meta: {
            nav: "workReport",
            navChild: "workQuality",
            navName:"工作质量概览",
            keepAlive: true
        },
    },
    {
        path: "/workReport/workQualityDetail",
        name: "workQualityDetail",
        components: {
            default: workQualityDetail,
        },
        meta: {
            nav: "workReport",
            navChild: "workQualityDetail",
            navName:"工作质量详情",
            keepAlive: true
        },
    }
]



// WEBPACK FOOTER //
// ./src/views/workReport/index.js